module.exports = __webpack_public_path__ + "img/momo.1df83bdc.png";